module.exports = __webpack_public_path__ + "static/img/03033B_2_3_C_20200123_fit.382c7ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/03033B_2_3_C_20200123_fit.png
// module id = 5PG7
// module chunks = 0